var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 0H28.8C30.56 0 32 1.44 32 3.2V28.8C32 30.56 30.56 32 28.8 32H3.2C1.44 32 0 30.56 0 28.8V3.2C0 1.44 1.44 0 3.2 0ZM9.6 27.2V12.8H4.8V27.2H9.6ZM7.2 10.08C5.6 10.08 4.32 8.8 4.32 7.2C4.32 5.6 5.6 4.32 7.2 4.32C8.8 4.32 10.08 5.6 10.08 7.2C10.08 8.8 8.8 10.08 7.2 10.08ZM22.4 27.2H27.2V18.08C27.2 15.04 24.64 12.48 21.6 12.48C20.16 12.48 18.4 13.44 17.6 14.72V12.8H12.8V27.2H17.6V18.72C17.6 17.4401 18.72 16.32 20 16.32C21.28 16.32 22.4 17.4401 22.4 18.72V27.2Z",
    fill: "#1B1D23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.b5b6df5e1ff9a3256bea6fc45e8ef4b4.svg";
export { ForwardRef as ReactComponent };